import React from 'react';
import InputField from 'components/InputField/InputField';
import PropTypes from 'prop-types';

const labels = {
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  email_confirmation: 'Confirm email',
  password: 'Password',
  company_name: 'Company'
}

const NewUserSponsorForm = ({
  user,
  user: {
    first_name,
    last_name,
    email,
    password,
    email_confirmation,
    user_type,
    company_name
  },
  onFieldChange,
  onSubmit,
  errors = {},
  termsOfService,
}) => {
  return (
    <div className="container_records">
      <div className="add_webinar add_user">
        <h3>Add User Sponsor</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            <div className="row">
              {
                [{
                  field_name: 'first_name',
                  value: first_name
                }, {
                  field_name: 'last_name',
                  value: last_name
                }].map(e => (
                  <InputField
                    className='col s12 m6'
                    label={labels[e.field_name]}
                    onChange={onFieldChange}
                    errors={errors[e.field_name]}
                    autoComplete='new-password'
                    {...e}
                  />
                ))
              }

              {
                [{
                  field_name: 'email',
                  value: email,
                  type: 'email',
                  className: 'col s12'
                }, {
                  field_name: 'email_confirmation',
                  value: email_confirmation,
                  type: 'email',
                  className: 'col s12'
                }, {
                  field_name: 'company_name',
                  value: company_name,
                  type: 'text',
                  className: 'col s12'
                }, {
                  field_name: 'password',
                  value: password,
                  type: 'password',
                  className: 'col s12'
                }].map(e => (
                  <InputField
                    className='col s12 m6'
                    label={labels[e.field_name]}
                    onChange={onFieldChange}
                    errors={errors[e.field_name]}
                    autoComplete='new-password'
                    {...e}
                  />
                ))
              }
              <div className="submit_center col s12">
                <button onClick={onSubmit} className="button_classic" type="button" name="button">
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
NewUserSponsorForm.defaultProps = {};

NewUserSponsorForm.propTypes = {
  user: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  errors: PropTypes.array,
};

export default NewUserSponsorForm;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/UserSponsor/NewUserSponsorForm.jsx
 **/